import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BrandService } from 'src/app/infraestructure/drive-adapter/brand-service/brand.service';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';
import { HeaderStyleService } from 'src/app/infraestructure/services-views/header-style-service/header-style.service';
import { Subscription } from 'rxjs';
import { IHeaderStyles } from 'src/app/domain/interfaces/views/interface-header-styles';
import { HeaderType } from 'src/app/domain/interfaces/header/header-type-enum';
import { SourceOfDomain } from 'src/app/domain/models/resources/source-of-domain-enum';
import { FunnelService } from 'src/app/infraestructure/drive-adapter/funnel-service/funnel.service';
import { FunnelFlow } from 'src/app/domain/models/funnel/register-funnels/funnel-flow-register';
import { Brand } from 'src/app/domain/models/funnel/brand-enum';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() ShowMenuMobile = true;
  @Input() RedirectWithLogo = true;  
  @Input() headerType: HeaderType = HeaderType.Basic;
  public HeaderType = HeaderType;
  public brandResources!: IBrandResources;
  private headerStylesSubscription!: Subscription;
  public showClassVerify? = false;
  public FunnelFlow: FunnelFlow = { UserTemporary: { addresses: [] }};
  public environment = environment;
  public headerStyles: IHeaderStyles = {
    opacity: 1,
    logo: "",
    class: "bg-dark"
  }

  constructor(private brandService: BrandService, private headerStyleService: HeaderStyleService, private funnelService: FunnelService) { }

  ngOnInit(): void {
    this.brandService.getBrandResources().subscribe((brandResourcesResponse: IBrandResources) => {
      this.brandResources = brandResourcesResponse;
      
      if(this.brandResources?.brand?.toString() == Brand[Brand.Finsights] && (this.headerType == HeaderType.MemberPortal || this.headerType == HeaderType.Login)) {
        this.headerType = HeaderType.MemberPortalFinsights;
      }
      
      this.headerStylesSubscription = this.headerStyleService.currentheaderStyles.subscribe(x => {
        this.headerStyles = x;
        if (!this.headerStyles?.logo) this.headerStyles!.logo = this.environment.assetsURL + this.brandResources?.pathLogoWhite!;
      });
      this.showClassVerify = this.brandResources?.domains && this.brandResources?.domains?.some(domain => domain.includes(SourceOfDomain.VerifyFinancialProfile));
    });
    this.ListenStepChanged();
  }

  ngOnDestroy(): void {
    this.headerStylesSubscription?.unsubscribe();
  }

  ListenStepChanged() {
    this.funnelService.GetUserRegister().subscribe((FunnelFlow: FunnelFlow) => {
      if(!FunnelFlow) {
        this.FunnelFlow = { UserTemporary: { addresses: [] }, Step: 0 };
        return;
      }
      this.FunnelFlow = FunnelFlow;
    });
  }
}
